<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/sealApply/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width" label-width="100px">
        <el-form-item label="申请单号" prop="applyNo">
          <el-input v-model="searchForm.applyNo" placeholder="请输入申请单号"></el-input>
        </el-form-item>
        <el-form-item label="申请标题" prop="applyTitle">
          <el-input v-model="searchForm.applyTitle" placeholder="请输入申请标题"></el-input>
        </el-form-item>
        <el-form-item label="当前状态" prop="currentStatus">
          <el-select v-model="searchForm.currentStatus" clearable placeholder="请选择状态">
            <el-option v-for="(item, index) of statusList" :value="item.value" :label="item.label" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="160" label="申请单号" prop="applyNo"></el-table-column>
        <el-table-column min-width="150" label="申请标题" prop="applyTitle"></el-table-column>
        <el-table-column min-width="120" label="申请人" prop="applyUserName"></el-table-column>
        <el-table-column min-width="150" label="申请时间" prop="applyTime"></el-table-column>
        <el-table-column min-width="200" label="用印事由描述" prop="useDesc"></el-table-column>
        <el-table-column min-width="120" label="签章人" prop="userName"></el-table-column>
        <!-- <el-table-column min-width="150" label="印章id" prop="sealId"></el-table-column> -->
        <el-table-column min-width="120" label="当前状态" prop="currentStatus">
          <template v-slot="{ row }">
            <el-tag type="warning" v-if="row.currentStatus == '1'">{{ sealApplyStatusMap.get(row.currentStatus) }}</el-tag>
            <el-tag type="success" v-else-if="row.currentStatus == '2'">{{ sealApplyStatusMap.get(row.currentStatus) }}</el-tag>
            <el-tag type="info" v-else-if="row.currentStatus == '3'">{{ sealApplyStatusMap.get(row.currentStatus) }}</el-tag>
            <el-tag type="danger" v-else-if="row.currentStatus == '4'">{{ sealApplyStatusMap.get(row.currentStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="150" label="创建时间" prop="createTime"></el-table-column>
        <el-table-column min-width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" size="small" v-if="row.currentStatus === '2' && row.userId.includes(userId)" @click="goSign(row)">去签章</el-button>
            <el-button type="text" size="small" v-if="row.currentStatus === '3' && hasYongyin" @click="goSign(row)">去签章</el-button>
            <el-button type="text" size="small" v-if="row.currentStatus === '1' && hasApproval" @click="goApproval(row.applyId)">审批</el-button>
            <el-button type="text" size="small" @click="goDetail(row.applyId)">详情</el-button>
            <el-button type="text" class="del-btn" size="small" v-if="row.currentStatus != '3' && hasDel" @click="deleteRow(row.applyId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total" @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { sealApplyStatus } from '@/utils/dict'

export default {
  name: 'SealApply',
  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      sealApplyStatusMap: sealApplyStatus,
      searchForm: {
        applyNo: '',
        applyTitle: '',
        currentStatus: ''
      },
      statusList: [
        {
          label: '审批中',
          value: '1'
        },
        {
          label: '已批准',
          value: '2'
        },
        {
          label: '已用印',
          value: '3'
        },
        {
          label: '已驳回',
          value: '4'
        }
      ]
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasYongyin() {
      return this.buttonList.includes('yongyin')
    },
    userInfo() {
      return this.$store.state.user
    },
    userId() {
      return this.userInfo.userId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.sealApply.selectSealApplyByPage, {
        params: {
          page: this.page,
          size: 10,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    // 判断是否可以签章
    canSign(row) {
      // 条件：审批通过且当前登录人id在签章人id列表内
      return row.currentStatus === '2' && row.userId.includes(this.userId)
    },
    // 去签章
    goSign(row) {
      this.$axios.post(this.$apis.sealApply.updateSealApply, {
        applyId: row.applyId
      }).then(res => {
        if (res) {
          window.open(res, '_blank')
        }
      }).catch(error => {
        this.$message.error('获取签章链接失败：' + error.message)
      })
    },
    // 删除申请
    deleteRow(applyId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.sealApply.deleteDataSealApply, {
          applyId
        }).then(() => {
          this.loadData()
        }).catch(error => {
          this.$message.error('删除失败：' + error.message)
        })
      })
    },
    // 去审批
    goApproval(applyId) {
      this.$router.push(`/sealApply/detail?applyId=${applyId}&isApproval=true`)
    },
    // 去详情
    goDetail(applyId) {
      this.$router.push(`/sealApply/detail?applyId=${applyId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.account-form {
  .el-select,
  .el-input {
    width: 200px !important;
  }
}
</style>
